import { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { FaEye, FaEdit, FaTrash, FaCommentDots, FaTimes, FaUserPlus, FaPhoneAlt } from 'react-icons/fa';
import { useDispatch } from "react-redux";
import { successToast, errorToast } from '../../Utils/toast';
import { openModal } from "../../redux/features/modalSlice";
import { STATUS_OPTIONS } from '../../Constant/leadConstent';
import LeadFilters from '../../common/leadFilter';
import Pagination from '../../common/Pagination';
import { startAiCall, startAiCallByLeadType } from "../../redux/services/Ai Services/Ai.Services"

import Search from "../../common/Search";
import Swal from "sweetalert2";
import {
    assignLeadStore,
} from "../../redux/services/AssignTask Services/AssignTask.Services";
import { getadminPendingLeadList, updateLeadStatus, deleteLead } from "../../redux/services/leadServices/Lead.Services"
import { getAdminData, activeLeadType, rowsForVendorList, leadTypeLabel, listPageMeta } from '../../Utils/role';

function AdminPendingLeadList() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const leadType = activeLeadType(searchParams.get("lead_type"));
    const typeLabel = leadTypeLabel(leadType);
    const role = localStorage.getItem("role");
    const isAdmin = getAdminData();
    const [leadData, setLeadData] = useState([]);
    const [aiCallLoading, setAiCallLoading] = useState(false);
    const [showRemarkPopup, setShowRemarkPopup] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const [activeFilter, setActiveFilter] = useState("all");
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    const [totalLeads, setTotalLeads] = useState(0);
    const [selectedRemark, setSelectedRemark] = useState("");
    const [totalPages, setTotalPages] = useState(1);
    const [limit, setLimit] = useState(100);
    const [showFilter, setShowFilter] = useState(false);
    const [selectedLeadIds, setSelectedLeadIds] = useState([]);
    const [assignLoading, setAssignLoading] = useState(false);
    const [userId, setUserId] = useState(null);

    const handleDelete = async (id) => {
        try {
            const res = await deleteLead({
                id: id,
            });
            successToast(res?.message);
            const updatedLeads = leadData.filter(item => item.id !== id);
            setLeadData(updatedLeads); // Fix: Update state properly
        } catch (error) {
            errorToast(
                error?.response?.data?.message ||
                error?.message ||
                "Delete failed"
            );
        }
    };

    // Updated assign function with modal
    const handleAssignClick = () => {
        if (selectedLeadIds.length === 0) {
            return Swal.fire({
                title: "No Selection",
                text: "Please select at least one lead to assign",
                icon: "warning",
                confirmButtonText: "OK",
            });
        }
        dispatch(
            openModal({
                type: "assign-leads",
                title: "Assign Selected Leads",
                data: {
                    leadIds: selectedLeadIds,
                    onAssign: assignSelectedLeads,
                    isLoading: assignLoading,
                },
            })
        );
    };

    const assignSelectedLeads = async (userId) => {
        if (!userId) {
            return errorToast("Please select a staff member");
        }

        try {
            setAssignLoading(true);

            const payload = {
                user_id: userId,
                task_ids: selectedLeadIds,
            };
            const response = await assignLeadStore(payload);

            if (response?.status === true || response?.success === true) {
                // Remove assigned leads from list
                setLeadData(prev =>
                    prev.filter(lead => !selectedLeadIds.includes(lead.id))
                );
                setSelectedLeadIds([]);

                successToast(response?.message || "Leads assigned successfully 🚀");

                // Close modal if needed
                // You might want to dispatch close modal action here
            } else {
                errorToast(response?.message || "Assignment failed");
            }
        } catch (error) {
            console.error("Assignment Error:", error);
            errorToast(error?.response?.data?.message || "Assignment failed");
        } finally {
            setAssignLoading(false);
        }
    };

    const pageLeadIds = (leadData || []).map((lead) => lead.id).filter(Boolean);
    const allPageSelected =
        pageLeadIds.length > 0 && pageLeadIds.every((id) => selectedLeadIds.includes(id));
    const handleSelectAll = (e) => {
        setSelectedLeadIds(e.target.checked ? pageLeadIds : []);
    };
    const getVendorId = (lead) => {
        return (
            lead?.vendor_id ||
            lead?.vendor?.id ||
            lead?.vendor?.vendor_id ||
            null
        );
    };
    const getSelectedLeads = () => {
        return leadData.filter((lead) =>
            selectedLeadIds.includes(lead.id)
        );
    };
    const handleRemarkClick = (remark) => {

        setSelectedRemark(remark || "No Remark");
        setShowRemarkPopup(true);
    };
    const handleAiCalling = async () => {
        const selectedLeads = getSelectedLeads();
        if (!selectedLeads.length) {
            return errorToast("Please select at least one lead");
        }
        try {
            setAiCallLoading(true);
            if (leadType) {
                await startAiCallByLeadType({
                    leads: selectedLeads.map((lead) => ({
                        lead_id: lead.lead_id,
                        name: lead.name,
                        phone: lead.mobile,
                        lead_type: leadType,
                        language: "hi",
                    })),
                });
            } else {
                const vendorId = getVendorId(selectedLeads[0]);
                for (const lead of selectedLeads) {
                    const payload = {
                        vendor_id: String(vendorId),

                        leads: selectedLeads.map((item) => ({
                            name: item.name,
                            lead_id: item.lead_id,
                            phone: item.mobile,
                            language: "hi",
                        })),
                    };
                    await startAiCall(payload);
                }
            }
            successToast("AI calling started successfully");
            setSelectedLeadIds([]);
        } catch (error) {
            console.error("AI Calling Error:", error);
            errorToast(
                error?.response?.data?.message ||
                error?.message ||
                "AI calling failed"
            );
        } finally {
            setAiCallLoading(false);
        }
    };

    const handleWhatsappMessage = async () => {
        const selectedLeads = getSelectedLeads();
        if (!selectedLeads.length) {
            return errorToast("Please select at least one lead");
        }
        const payload = selectedLeads.map((lead) => ({
            lead_id: lead.id,
            vendor_id: getVendorId(lead),
            phone: lead.mobile,
        }));
        console.log("WhatsApp Payload:", payload);
    };
    const handlePageChange = (newPage) => {
        if (
            newPage >= 1 &&
            newPage <= totalPages &&
            !tableLoading
        ) {
            setPage(newPage);
            fetchLeads(newPage, false);
        }
    };
    const toggleLeadSelection = (id) => {
        setSelectedLeadIds((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };

    const handleStatusUpdate = async (data) => {
        try {
            await updateLeadStatus(data);
            Swal.fire({
                icon: "success",
                title: "Status Updated",
                text: "Lead status successfully updated!",
                timer: 1500,
                showConfirmButton: false
            });
            await fetchLeads(page);
        } catch (error) {
            console.log(error);
            errorToast("Status update failed");
        }
    };

    useEffect(() => {
        fetchLeads(1, true);
    }, [leadType]);
    const fetchLeads = async (pageNo = 1, isInitialLoad = false) => {
        try {
            if (isInitialLoad) {
                setInitialLoading(true);
            } else {
                setTableLoading(true);
            }
            const payload = {
                page: pageNo,
                per_page: limit,
                search: search,
                ...(leadType ? { lead_type: leadType } : {}),
            };
            const response = await getadminPendingLeadList(payload);
            const leads = rowsForVendorList(response?.data || [], leadType, "Pending");
            const pageMeta = listPageMeta(response, leads.length, limit);
            setLeadData(leads);
            setPage(pageMeta.page);
            setTotalPages(pageMeta.pages);
            setTotalLeads(pageMeta.total);
            setSelectedLeadIds([]);
        } catch (error) {
            console.log(error);
            errorToast("Failed to fetch leads");
        } finally {
            setInitialLoading(false);
            setTableLoading(false);
        }
    };
    const handleBulkAction = (action) => {
        switch (action) {
            case "ai_calling":
                handleAiCalling();
                break;

            case "whatsapp_message":
                handleWhatsappMessage();
                break;

            default:
                break;
        }
    };
    useEffect(() => {
        if (initialLoading) return;
        fetchLeads(1, false);
    }, [search]);
    const handleToggleFilter = () => {
        setShowFilter(!showFilter);
    };

    if (initialLoading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary"></div>
            </div>
        );
    }


    return (
        <div>

            <div className="d-flex align-items-center justify-content-between  page-header-breadcrumb">
                <div className="title_member">
                    <h4>{typeLabel ? `${typeLabel} Pending Lead List` : "Pending Lead List"}</h4>
                    <nav className="page-breadcrumb">
                        <Link to="/">Home</Link>
                        <span className="mx-2">/</span>
                        <span>{typeLabel ? `${typeLabel} Pending Leads` : "Pending Leads"}</span>
                    </nav>
                </div>



                <div className="d-flex flex-wrap gap-2 justify-content-end">
                    <div className="d-flex flex-wrap gap-2 justify-content-end">
                        {selectedLeadIds.length > 0 && (
                            <select
                                className="form-select"
                                style={{ width: "200px" }}
                                defaultValue=""
                                onChange={(e) => {
                                    handleBulkAction(e.target.value);
                                    e.target.value = "";
                                }}
                            >
                                <option value="">Select Action</option>

                                <option value="ai_calling">
                                    AI Calling
                                </option>

                                <option value="whatsapp_message">
                                    WhatsApp Message
                                </option>
                            </select>
                        )}
                        {role === "admin" && (
                            <>
                                <button
                                    onClick={() => navigate(leadType ? `/add-lead?lead_type=${leadType}` : "/add-lead")}
                                    className="lead-btn btn-import"
                                >
                                    Add Lead
                                </button>

                                <button
                                    className="lead-btn btn-import"
                                    onClick={() =>
                                        dispatch(
                                            openModal({
                                                type: "import-lead",
                                                title: "Import Leads",
                                                data: leadType ? { lead_type: leadType } : null,
                                            })
                                        )
                                    }
                                >
                                    Import Lead
                                </button>
                            </>
                        )}
                        {/* Add Assign Button */}
                        {/* {selectedLeadIds.length > 0 && (
                            <button
                                className="lead-btn btn-import"
                                onClick={handleAssignClick}
                                disabled={assignLoading}
                            >
                                <FaUserPlus className="me-2" />
                                Assign Selected ({selectedLeadIds.length})
                            </button>
                        )} */}
                    </div>


                </div>



            </div>














            <div className="main_page">

                {totalPages > 1 && (
                    <div className="d-flex justify-content-between align-items-center flex-wrap">

                        <Search
                            search={search}
                            placeholder="Search Lead..."
                            onSearch={(value) => {
                                setSearch(value);
                                setPage(1);
                            }}
                        />




                        <div className="col-12 d-flex justify-content-end">

                            <Pagination
                                page={page}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                            />
                        </div>


                    </div>
                )}
                <div className="st-wrapper-card text-center">
                    <div className="st-table-responsive">
                        <table className="table st-custom-table align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>
                                        <label className="d-inline-flex align-items-center gap-1 mb-0">
                                            <input
                                                type="checkbox"
                                                aria-label="Select all on this page"
                                                checked={allPageSelected}
                                                onChange={handleSelectAll}
                                            />
                                            All
                                        </label>
                                    </th>
                                    <th>Sr.No.</th>
                                    <th>Lead Id</th>
                                    <th> Name</th>
                                    <th> Mobile No</th>
                                    <th> Source</th>
                                    {/* <th> Assigned By</th>
                                {role === "admin" && <th>Assigned To</th>} */}
                                    {/* <th>Assigned</th>
                                <th>Status</th>
                                <th>Remark</th> */}
                                    <th>Remark</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableLoading ? (
                                    <tr>
                                        <td colSpan={7} className="text-center py-5">
                                            <div className="spinner-border text-primary"></div>
                                        </td>
                                    </tr>
                                ) : (
                                    leadData?.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedLeadIds.includes(item.id)}
                                                    onChange={() => toggleLeadSelection(item.id)}
                                                />
                                            </td>
                                            <td>{(page - 1) * limit + index + 1}</td>
                                            <td>{item.lead_id}</td>
                                            <td className="fw-semibold" style={{ whiteSpace: "nowrap" }}>{item?.name}</td>
                                            <td>{item.mobile}</td>
                                            <td>
                                                <span
                                                    className={`source-badge ${item.source === "Website"
                                                        ? "website"
                                                        : item.source === "Facebook"
                                                            ? "facebook"
                                                            : item.source === "Justdial"
                                                                ? "instagram"
                                                                : item.source === "IndiaMART"
                                                                    ? "indiamart"
                                                                    : ""
                                                        }`}
                                                >
                                                    {item.source}
                                                </span>
                                            </td>
                                            <td className=''>
                                                <div
                                                    className="remark-cell text-link"
                                                    style={{
                                                        cursor: "pointer",
                                                        maxWidth: "150px",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap"
                                                    }}
                                                    onClick={() => handleRemarkClick(item.remarks)}
                                                >
                                                    {item.remarks || "-"}
                                                </div>
                                            </td>

                                            <td>

                                                <div className="d-flex align-items-center justify-content-center gap-1">
                                                    <button
                                                        className="st-action-btn st-view-btn"
                                                        onClick={() => navigate(`/view-lead/${item.id}`)}
                                                    >
                                                        <FaEye />
                                                    </button>
                                                    <button
                                                        className="st-action-btn st-view-btn"
                                                        title="Call History"
                                                        onClick={() =>
                                                            navigate(`/view-call-detail/${item.mobile}`)
                                                        }
                                                    >
                                                        <FaPhoneAlt />
                                                    </button>
                                                    {isAdmin && (
                                                        <button
                                                            className="st-action-btn st-edit-btn"
                                                            // onClick={() => {
                                                            //     dispatch(
                                                            //         openModal({
                                                            //             type: "update-status",
                                                            //             title: "Update Lead Status",
                                                            //             data: {
                                                            //                 id: item.id,
                                                            //                 status: item.status,
                                                            //                 statusOptions: STATUS_OPTIONS,
                                                            //                 role,
                                                            //                 onSubmit: updateLeadStatus,
                                                            //                 onSuccess: () => {
                                                            //                     fetchLeads();
                                                            //                 },
                                                            //             },
                                                            //         })
                                                            //     );
                                                            // }}
                                                            onClick={() => navigate(`/update-lead/${item.id}`)}
                                                        >
                                                            <FaEdit />
                                                        </button>
                                                    )}

                                                    {role === "admin" && (
                                                        <button
                                                            className="st-action-btn st-delete-btn"
                                                            onClick={() =>
                                                                dispatch(
                                                                    openModal({
                                                                        type: "delete-lead",
                                                                        title: "Delete Lead",
                                                                        data: {
                                                                            id: item.id,
                                                                            deleteFunction: deleteLead,
                                                                            refreshData: () => fetchLeads(page),
                                                                        },
                                                                    })
                                                                )
                                                            }
                                                        >
                                                            <FaTrash />
                                                        </button>
                                                    )}

                                                    <button
                                                        className="st-action-btn st-edit-btn"
                                                        onClick={() => navigate(`/remark-history/${item.id}`)}
                                                    >
                                                        <FaCommentDots />
                                                    </button>
                                                </div>

                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>

                            {totalPages > 1 && (
                                <div className="d-flex justify-content-end mb-3">
                                    <Pagination
                                        page={page}
                                        totalPages={totalPages}
                                        onPageChange={handlePageChange}
                                    />
                                </div>
                            )}
                            {!tableLoading && leadData.length === 0 && (
                                <tr>
                                    <td colSpan="8" className="text-center py-4">
                                        No Pending Leads Found
                                    </td>
                                </tr>
                            )}
                        </table>
                    </div>
                </div>
            </div>


            {showRemarkPopup && (
                <div
                    className="modal fade show"
                    style={{
                        display: "block",
                        backgroundColor: "rgba(0,0,0,0.5)"
                    }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Remark Details
                                </h5>

                                <button
                                    type="button"
                                    className="btn-close text-light"
                                    style={{ background: "transparent", }}
                                    onClick={() => setShowRemarkPopup(false)}
                                >   <FaTimes /></button>
                            </div>

                            <div className="modal-body">
                                <p style={{ whiteSpace: "pre-wrap" }}>
                                    {selectedRemark}
                                </p>
                            </div>

                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setShowRemarkPopup(false)}
                                >
                                    Close
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default AdminPendingLeadList;